var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg710(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "reverse",
    fillRule: "evenodd",
    strokeWidth: 1.8,
    transform: "translate(1.314675, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "base",
    stroke: "#687577",
    fill: "#FFFFFF",
    d: "M9.602328,31.3633565 C8.65469289,31.3860675 7.70664077,31.3413819 6.76536284,31.2296388 C-3.19744231e-14,29.8511054 -3.19744231e-14,23.8730956 -3.19744231e-14,16.9532029 C-3.19744231e-14,8.79986753 3.39579794,-4.26325641e-13 8.88160976,-4.26325641e-13 C12.7782516,-4.26325641e-13 16.8060587,3.85989333 18.4583951,9.18172127 C19.120089,11.3125892 19.3285726,13.2828579 19.1777326,15.9785799 C19.0935108,17.4863507 19.0966173,18.9162344 19.0993787,20.299248 C19.110079,25.3632902 19.1193986,29.7370318 14.0867971,31.0976442 C13.4330421,31.2740965 11.3920426,31.3633565 9.602328,31.3633565 Z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.700000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hookstyle",
    transform: "scale(-1, 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "hook",
    fill: "none",
    transform: "translate(-8.000000, -9.000000)",
    d: "M3.58716581,4.86252597 C3.06706263,4.62380711 2.85229747,4.03585383 3.10747439,3.54929557 C3.36265132,3.06273731 3.99114002,2.86182379 4.5112432,3.10054265 C5.46056455,3.53626565 6.39450266,4.14450585 7.31484578,4.922185 C8.2443698,5.70762188 10.0438875,7.8539425 12.8028208,11.4459993 C13.1408693,11.8861293 13.0335172,12.4992928 12.5630432,12.8155382 C12.0925692,13.1317837 11.4371322,13.0313555 11.0990837,12.5912255 C8.44101017,9.13048544 6.68104531,7.03134029 5.90861111,6.37864246 C5.12699602,5.71818688 4.35258484,5.21384081 3.58716581,4.86252597 Z"
  }))), /*#__PURE__*/React.createElement("line", {
    id: "extracted",
    stroke: "none",
    strokeLinecap: "square",
    x1: 2.3998859,
    y1: 8.20392171,
    x2: 15.6853254,
    y2: 28.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg710);
export default __webpack_public_path__ + "static/media/7-10.ddc3f0c5e811b16157dfce72c15078fe.svg";
export { ForwardRef as ReactComponent };